import loadable from '@loadable/component';
var TravelVideoAcceptanceAgreementController = /** @class */function () {
  function TravelVideoAcceptanceAgreementController() {
    this.pageId = 'page.travel-video.acceptance-agreement';
    this.path = '/travel-video/video-acceptance-agreement';
    this.legacyPath = '/:localeName/travel-video/video-acceptance-agreement';
    this.routeName = 'travel-video-acceptance-agreement';
    this.bundles = [];
    this.component = loadable(
    /* istanbul ignore next */
    {
      resolved: {},
      chunkName() {
        return "travel-video-acceptance-agreement";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import(/* webpackChunkName: "travel-video-acceptance-agreement" */'./video-acceptance-agreement.view');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./video-acceptance-agreement.view");
        }
        return eval('require.resolve')("./video-acceptance-agreement.view");
      }
    });
    this.exact = true;
  }
  // tslint:disable-next-line:prefer-function-over-method
  TravelVideoAcceptanceAgreementController.prototype.fetch = function () {
    return Promise.resolve({});
  };
  // tslint:disable-next-line:prefer-function-over-method
  TravelVideoAcceptanceAgreementController.prototype.fetchPageData = function () {
    var pageData = {
      title: 'Travel Video Program - Expedia Group',
      seo: {
        canonical: "https://affiliates.expediagroup.com/travel-video",
        description: 'Share videos of the amazing properties you stayed in with us. You could earn $150 for every video we feature on our sites, apps, social media, and more!'
      },
      clickstreamPageName: 'Travel Video Acceptance Agreement Page',
      clickstreamPageNameDetailed: 'Travel Video Acceptance Agreement Page'
    };
    return Promise.resolve(pageData);
  };
  return TravelVideoAcceptanceAgreementController;
}();
export { TravelVideoAcceptanceAgreementController };